import { useQuery } from "@tanstack/react-query";

import Axios from "@/lib/axios-instance";

export interface MonthlyRevenueData {
  month: string;
  total_income: number;
  total_refunds: number;
  net_income: number;
}

export const getMonthlyRevenue = async (year: number) => {
  try {
    const response = await Axios.get<MonthlyRevenueData[]>(
      `/revenue_report/revenue/monthly?year=${year}`
    );
    return response.data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    if (error.response) {
      throw new Error(error?.response?.data?.message || error?.response?.data?.error || "Error fetching monthly revenue data");
    }
    throw new Error(error.message || "Network Error");
  }
};

export const useGetMonthlyRevenue = (year: number) => {
  return useQuery({
    queryKey: ["monthly_revenue", year],
    queryFn: () => getMonthlyRevenue(year),
    enabled: !!year,
  });
};